const emailUserOptions = [
  { value: "hrd@classicmarble.com", label: "HR Dept" },
  { value: "hrd@kalingastone.com", label: "HR Dept Unit 3" },
  {
    value: "dinesh.patil@classicmarble.com",
    label: "HR Dept Unit 1"
  },
  {
    value: "chiragprajapati781@gmail.com",
    label: "Chirag Prajapati"
  },
  {
    value: "inspact.io@gmail.com",
    label: "Inspact io"
  },
  { value: "deepak.jain@classicmarble.com", label: "Deepak Jain" },
  {
    value: "sanjay.khandelwal@classicmarble.com",
    label: "Sanjay Khandelwal"
  },
  {
    value: "priyanka.srivastava@classicmarble.com",
    label: "Priyanka Srivastava"
  }
];

export { emailUserOptions };
